import React from "react";

const EditContainer = () => {
  return <div>No edit options</div>;
};

export default EditContainer;
